// Styles
import s from '../styles/pages/MemoryNotFound.module.scss'
// Components
import { Container } from '../components/core/container/Container'
import { Section } from '../components/core/section/Section'
import { Text } from '../components/core/text/Text'
import Meta from '../components/meta/Meta'
import ServiceCard from '../slices/ServiceCard'

export default function MemoryNotFound() {
    return (
        <>
            <Section>
                <Meta
                    title="Minningarsíða finnst ekki"
                    seoTitle="Minningarsíða finnst ekki"
                    description="404"
                    type="website"
                    url=""
                    image="https://ik.imagekit.io/minningar/Minningar_7V4A5213_01-min_5-f7B_aBV.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1643189239548&tr=w-1200%2Ch-628%2Cfo-auto"
                />
                <Container>
                    <div className={s.content}>
                        <Text variant="h1">Minningarsíða finnst ekki</Text>
                        <Text variant="p-18">
                            Minningarsíða fyrir þann látna / þá látnu er ekki
                            til. Má bjóða þér að setja upp minningarsíðu? Eða
                            viltu benda aðstandendum að búa til minningarsíðu?
                        </Text>
                    </div>
                </Container>
            </Section>
            <ServiceCard
                slice={{
                    primary: {
                        title: 'Stofna minningarsíðu',
                        description:
                            'Minningar.is er vefur þar sem minningin lifir. Þú getur stofnað minningasíðu um látinn ástvin og deilt henni með öðrum.',
                        buttonLink: '/memories/form',
                        buttonText: 'Stofna minningarsíðu',
                    },
                }}
            />
        </>
    )
}
